export const enum DeliveryType {
  Express = 'express',
  SDD = 'sdd',
  NDD = 'ndd',
  Courier = 'courier',
  Cargo = 'cargo',
  Night = 'night',
  NDD_Self_Pickup = 'ndd_self_pickup',
  NDD_Shipment = 'ndd_shipment',
  Walking_Courier = 'walking_courier',
}
